module.exports = __webpack_public_path__ + "img/8fda701174a0626e68ba5d6541140d4d.png";